import { useState } from "react";
import './LoginPage.css';

const API_LOGIN = "https://login.dm-airtech.com/api/auth/password-login";
const API_ME    = "https://login.dm-airtech.com/api/auth/me";
const DM_ORG_ID = "0ffa5d85-a3ab-49a1-8ac6-9b69cf016b63";

export default function LoginPage({ onSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");

  async function handleLogin(e) {
    e.preventDefault();
    if (!username.trim() || !password) {
      setError("Please enter your username/email and password.");
      return;
    }
    setError("");
    setLoading(true);

    try {
      const r1 = await fetch(API_LOGIN, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: username.trim(), password }),
      });
      const d1 = await r1.json();
      if (!r1.ok) throw new Error(d1.detail || `Login failed (${r1.status})`);

      const r2 = await fetch(API_ME, {
        headers: { "X-User-API-Key": d1.api_key, accept: "application/json" },
      });
      const me = await r2.json();
      if (!r2.ok) throw new Error(me.detail || "Could not fetch user info.");

      if (me.org_id !== DM_ORG_ID) {
        throw new Error("Access restricted to DM AirTech organisation members only.");
      }

      onSuccess(d1.api_key, me);
    } catch (err) {
      setError(err.message || "An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <h1 className="login-title">SensorPlus</h1>
        <p className="login-message">
          Access The AI Meteorologist.
        </p>

        {error && <p className="login-error">{error}</p>}

        <form onSubmit={handleLogin}>
          <div className="login-input-group">
            <label htmlFor="username" className="login-label">
              Username or Email:
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={e => { setUsername(e.target.value); setError(""); }}
              required
              className="login-input"
              autoComplete="username"
              placeholder="e.g., Maverick or maverick@example.com"
            />
          </div>

          <div className="login-input-group">
            <label htmlFor="password" className="login-label">
              Password:
            </label>
            <div className="login-input-wrapper">
              <input
                type={showPass ? "text" : "password"}
                id="password"
                value={password}
                onChange={e => { setPassword(e.target.value); setError(""); }}
                required
                className="login-input"
                autoComplete="current-password"
                placeholder="••••••••"
              />
              <button
                type="button"
                onClick={() => setShowPass(p => !p)}
                className="login-toggle-btn"
                aria-label={showPass ? "Hide password" : "Show password"}
                tabIndex={-1}
              >
                {showPass ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          <div className="login-forgot">
            <a href="https://login.dm-airtech.com/forgot-password">Forgot password?</a>
          </div>

          <button type="submit" className="login-submit-btn" disabled={loading}>
            {loading ? "Authenticating..." : "Login"}
          </button>
        </form>

        <p className="login-register-text">
          Need an account for flight operations?{" "}
          <a href="https://login.dm-airtech.com/register">Register for Access</a>
        </p>
      </div>
    </div>
  );
}